import { useState } from 'react';
import { Alert, Button, Card, Input, message, Switch } from 'antd';
import forge from 'node-forge';
import { usePersistedStore } from '../../store/persisted-store';

const { TextArea } = Input;

const ExternalLogin = () => {
    const [key, setKey] = useState("");
    const [hasFailureUrl, setHasFailureUrl] = useState(false);
    const [failureUrl, setFailureUrl] = useState("");

    const { auth, business, } = usePersistedStore();
    const userInfo = auth?.userInfo;
    const mobileNumber = userInfo?.MobileNumber;
    const displayName = userInfo?.DisplayName;
    const lastName = userInfo?.LastName;
    const firstName = userInfo?.FirstName;
    const userName = userInfo?.UserName;
    const IssuedAt = Math.floor(Date.now() / 1000);

    const currentBusiness = business?.currentBusiness;
    const redirectDomain = currentBusiness?.data?.domain?.includes(",")
        ? currentBusiness?.data?.domain?.split(",")[1]
        : currentBusiness?.data?.domain;
    const isBimeh = currentBusiness?.data?.token === "da4aa2f8-70d9-4d56-b577-3162dfae2c0f";

    const displayNameHanler = () => {
        if (displayName) {
            return displayName;
        } else if (firstName && lastName) {
            return `${firstName} ${lastName}`;
        } else if (mobileNumber) {
            return mobileNumber;
        } else {
            return userName;
        }
    };

    const jwtItems = {
        UserName: mobileNumber || userName,
        DisplayName: displayNameHanler(),
        IssuedAt: IssuedAt,
    };

    async function encryptWithKey(publicKeyXml, dataObj) {
        try {
            const modulusMatch = publicKeyXml.match(/<Modulus>(.*?)<\/Modulus>/);
            const exponentMatch = publicKeyXml.match(/<Exponent>(.*?)<\/Exponent>/);

            if (!modulusMatch || !exponentMatch) {
                throw new Error("Invalid XML key");
            }

            const modulus = modulusMatch[1];
            const exponent = exponentMatch[1];

            const keySizeBytes = 2048 / 8;

            function base64ToBigInteger(b64, size) {
                let bytes = forge.util.decode64(b64);
                if (bytes.length < size) {
                    bytes = "\x00".repeat(size - bytes.length) + bytes;
                }
                return new forge.jsbn.BigInteger(forge.util.bytesToHex(bytes), 16);
            }

            const n = base64ToBigInteger(modulus, keySizeBytes);
            const e = new forge.jsbn.BigInteger(
                forge.util.bytesToHex(forge.util.decode64(exponent)),
                16
            );

            const publicKey = forge.pki.rsa.setPublicKey(n, e);

            const dataString = JSON.stringify(dataObj);

            const encrypted = publicKey.encrypt(dataString, "RSAES-PKCS1-V1_5");
            return forge.util.encode64(encrypted);
        } catch (error) {
            console.error("Encryption failed:", error);
            return null;
        }
    }

    const ensureLeadingSlash = (url) => {
        if (!url) return url;
        return url.startsWith("/") ? url : "/" + url;
    };

    // ----- ACTION HANDLERS -----
    const handleNewPost = async () => {
        const encrypted = await encryptWithKey(key, jwtItems);
        if (!encrypted)
            return message.error("خطا در رمزنگاری داده‌ها. لطفاً کلید را بررسی کنید.");

        const form = document.createElement("form");
        form.method = "POST";
        form.action = `https://${redirectDomain}/`;
        form.target = "_blank";

        const authInput = document.createElement("input");
        authInput.type = "hidden";
        authInput.name = "auth";
        authInput.value = encrypted;
        form.appendChild(authInput);

        if (hasFailureUrl && failureUrl) {
            const failureInput = document.createElement("input");
            failureInput.type = "hidden";
            failureInput.name = "failedurl";
            failureInput.value = ensureLeadingSlash(failureUrl);
            form.appendChild(failureInput);
        }

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    };

    const handleNewGet = async () => {
        const encrypted = await encryptWithKey(key, jwtItems);
        if (!encrypted)
            return message.error("خطا در رمزنگاری داده‌ها. لطفاً کلید را بررسی کنید.");

        const failed =
            hasFailureUrl && failureUrl
                ? `&failedurl=${encodeURIComponent(ensureLeadingSlash(failureUrl))}`
                : "";

        window.open(
            `https://${redirectDomain}?auth=${encodeURIComponent(encrypted)}${failed}`,
            "_blank"
        );
    };

    const handleOldPost = async () => {
        const encrypted = await encryptWithKey(key, jwtItems);
        if (!encrypted)
            return message.error("خطا در رمزنگاری داده‌ها. لطفاً کلید را بررسی کنید.");

        const form = document.createElement("form");
        form.method = "POST";
        form.action = `https://${redirectDomain}/api/user/externallogin`;
        form.target = "_blank";

        const authInput = document.createElement("input");
        authInput.type = "hidden";
        authInput.name = "userToken";
        authInput.value = encrypted;
        form.appendChild(authInput);

        const successInput = document.createElement("input");
        successInput.type = "hidden";
        successInput.name = "redirectSuccess";
        successInput.value = "/";
        form.appendChild(successInput);

        if (hasFailureUrl && failureUrl) {
            const failureInput = document.createElement("input");
            failureInput.type = "hidden";
            failureInput.name = "redirectUrl";
            failureInput.value = ensureLeadingSlash(failureUrl);
            form.appendChild(failureInput);
        }

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    };

    const handleOldGet = async () => {
        const encrypted = await encryptWithKey(key, jwtItems);
        if (!encrypted)
            return message.error("خطا در رمزنگاری داده‌ها. لطفاً کلید را بررسی کنید.");

        let url = `https://${redirectDomain}/api/user/externallogin?auth=${encodeURIComponent(
            encrypted
        )}`;
        if (hasFailureUrl && failureUrl) {
            url += `&redirectUrl=${encodeURIComponent(ensureLeadingSlash(failureUrl))}`;
        }
        window.open(url, "_blank");
    };

    const buttonStyle = { width: "120px", height: "40px" };

    return (
        <div>
            <Card className="mb-5">
                {isBimeh && (
                    <div className="mb-4">
                        <Alert
                            type="error"
                            message="انجام این فرایند در بیمه دات کام امکانپذیر نیست، لطفا بیزینس خود را تغییر دهید."
                        />
                    </div>
                )}

                <h4>اکسترنال لاگین</h4>
                <div className="external-login-form d-flex flex-row gap-3">
                    <div className='col-10'>
                        <div>
                            <label className="mr-3 mb-0">کلید:</label>
                            <TextArea
                                required
                                style={{ textAlign: "left" }}
                                rows={6}
                                value={key}
                                onChange={(e) => setKey(e.target.value)}
                                placeholder="Paste XML format RSA public key"
                            />
                        </div>

                        <div className='mt-1'>
                            <label>آدرس ناموفق دارد؟</label>
                            <Switch
                                checked={hasFailureUrl}
                                onChange={(checked) => setHasFailureUrl(checked)}
                                className="ml-2"
                            />
                            {hasFailureUrl && (
                                <Input
                                    required
                                    className="col-12 mt-2"
                                    placeholder="آدرس ناموفق را وارد کنید"
                                    value={failureUrl}
                                    onChange={(e) => setFailureUrl(e.target.value)}
                                />
                            )}
                        </div>
                    </div>
                    <div className="d-flex col-2 flex-column flex-wrap align-items-end gap-3 mt-3">
                        <Button
                            disabled={!key || isBimeh || (hasFailureUrl && !failureUrl)}
                            style={buttonStyle}
                            type="primary"
                            onClick={handleNewPost}
                        >
                            جدید POST
                        </Button>
                        <Button
                            disabled={!key || isBimeh || (hasFailureUrl && !failureUrl)}
                            style={buttonStyle}
                            type="primary"
                            onClick={handleNewGet}
                        >
                            جدید GET
                        </Button>
                        <Button
                            disabled={!key || isBimeh || (hasFailureUrl && !failureUrl)}
                            style={buttonStyle}
                            type="primary"
                            onClick={handleOldPost}
                        >
                            قدیم POST
                        </Button>
                        <Button
                            disabled={!key || isBimeh || (hasFailureUrl && !failureUrl)}
                            style={buttonStyle}
                            type="primary"
                            onClick={handleOldGet}
                        >
                            قدیم GET
                        </Button>
                    </div>
                </div>
            </Card>
        </div>
    );
};

export default ExternalLogin;
